import React from "react";
import {
  Avatar,
  Box,
  Chip,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import DirectionsIcon from "@mui/icons-material/Directions";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useTranslation } from "../i18n/useTranslation";

const RouteBoard = ({ routes, selectedRoutes = [], onToggleRoute, trainsByRoute }) => {
  const { t, translateRouteName, translateRouteSubtitle } = useTranslation();
  return (
    <Grid container spacing={2.5}>
      {routes.map((route) => {
        const isActive =
          !selectedRoutes.length || selectedRoutes.includes(route.id);
        const trainCount = trainsByRoute[route.id]?.length || 0;
        const firstStation = route.stations[0];
        const lastStation = route.stations[route.stations.length - 1];
        const routeName = translateRouteName(
          route.id,
          route.displayName || route.name
        );
        const routeSubtitle = translateRouteSubtitle(
          route.id,
          route.displaySubtitle || route.subtitle
        );

        return (
          <Grid item xs={12} md={6} lg={4} key={route.id}>
            <Paper
              onClick={() => onToggleRoute(route.id)}
              elevation={isActive ? 6 : 1}
              sx={{
                p: 3,
                borderRadius: 2,
                cursor: "pointer",
                position: "relative",
                overflow: "hidden",
                bgcolor: "background.paper",
                border: isActive
                  ? `2px solid ${route.color}`
                  : "1px solid rgba(15, 23, 42, 0.08)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 12px 30px rgba(15, 23, 42, 0.12)",
                },
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  background: route.accent,
                  opacity: 0.22,
                  zIndex: 0,
                }}
              />

              <Stack spacing={2.5} sx={{ position: "relative", zIndex: 1 }}>
                <Stack direction="row" spacing={2} alignItems="center">
                  <Avatar
                    sx={{
                      bgcolor: route.color,
                      color: "#fff",
                      width: 48,
                      height: 48,
                    }}
                  >
                    <DirectionsIcon />
                  </Avatar>

                  <Stack spacing={0.5}>
                    <Typography variant="subtitle2" color="text.secondary">
                      {routeSubtitle}
                    </Typography>
                    <Typography variant="h6" sx={{ fontWeight: 700 }}>
                      {routeName}
                    </Typography>
                  </Stack>
                </Stack>

                <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                  <Chip
                    label={t("route.stations", { count: route.totalStations })}
                    sx={{ bgcolor: "rgba(15,23,42,0.05)", borderRadius: 999 }}
                  />
                  <Chip
                    label={t("route.trains", { count: trainCount })}
                    sx={{ bgcolor: "rgba(15,23,42,0.05)", borderRadius: 999 }}
                  />
                </Stack>

                <Stack direction="row" alignItems="center" spacing={1}>
                  <Typography variant="body2" color="text.secondary">
                    {firstStation?.name}
                  </Typography>
                  <ArrowForwardIcon sx={{ fontSize: 20, color: route.color }} />
                  <Typography variant="body2" color="text.secondary">
                    {lastStation?.name}
                  </Typography>
                </Stack>
              </Stack>
            </Paper>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default RouteBoard;
